import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { NotificationCard } from "../../";
export const ErrorCard = ({ id, title, message }) => {
    return (_jsx(NotificationCard, { id: id, variant: "error", title: title, message: message }));
};
//# sourceMappingURL=ErrorCard.js.map